export default __webpack_public_path__ + "static/media/CommerceDept.e6dbc951.png";